class RangeToStepsConverterBase{
    /**
     * Generates collection of arrays, each containing 2 values, first one defines beginning of range, second defines end of range
     * @param {*} min 
     * @param {*} max 
     * @returns {Array}
     */
    getSteps(min, max){
        return [
            [min, max]
        ];
    }
}

export default RangeToStepsConverterBase;